<template>
  <div class="container-warp">
    <Top-Nav pageTitle="问卷列表" :leftArrow='false'></Top-Nav>

    <div class="survey-list">
      <div class="survey-list-item"
           v-for="(item, index) in listData"
           :key="index"
           @click="jumpSurveyPage(item)">
        <div class="survey-info">
          <div class="info-tit">
            <span class="cut-word">{{item.content}}</span>
            <van-icon name="notes-o" color="#017A3F" size="22" />
          </div>
          <div class="info-text van-multi-ellipsis--l3">{{item.surveyDes}}</div>
        </div>
      </div>

      <!-- 无数据 -->
      <van-empty v-if="listData.length == 0" image="error" description="暂无数据" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { surveyList } from "@/api/survey.js";
import {getSysConfig} from "@/api/common.js";
import { Dialog } from 'vant';
export default {
  name: 'SurveyList',
  data() {
    return {
      listData: []
    }
  },
  computed: {
    ...mapGetters(["userCode"]),
  },
  created() {
    this.getSurveyList()
    this.getSystemConfig()
  },
  methods: {
    // 获取系统参数
    async getSystemConfig() { 
      const { status, data } = await getSysConfig('questionnaire_notice')
      if (status == 200) {
        console.log(data)
        Dialog.alert({
          title: '提示',
          message: `${data.questionnaire_notice}`,
          theme: 'round-button',
        }).then(() => {
          // on close
        });
      }
    },
    // 获取问卷调查数据
    async getSurveyList() { 
      const params = { userCode: this.userCode} 
      const { status, data } = await surveyList(params)
      if (status == 200) {
        this.listData = data
      }
    },
    jumpSurveyPage(item) {
      this.$router.push({
        path: '/survey',
        query: { surveyId: item.id }
      });
    }
  },
}
</script>

<style lang="less" scoped>
.survey-list {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;

  .survey-list-item {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 16px 12px;
    background-color: #fff;
    margin-bottom: 12px;
    border-radius: 8px;
    box-sizing: border-box;

    .survey-info {
      width: 100%;

      .info-tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 6px;
        color: #017A3F;
      }

      .info-text {
        font-size: 12px;
        font-weight: 400;
        color: #888888;
        line-height: 1.6;
      }
    }
  }
}
</style>